import { GET_INSTA_PHOTOS } from '../actions/types';

const instagramPhotos = (state = {}, action) => {
  switch (action.type) {
    case GET_INSTA_PHOTOS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default instagramPhotos;